import apiUrl from '../../../utils/settings';

export const getCompanySuppliersUrl = () => {
  return apiUrl + '/company/suppliers';
};
export const getBenefitFlyers = () => {
  return apiUrl + '/benefit-packages/flyers';
};
export const getPoBaseProductUrl = () => {
  return apiUrl + '/order-booking/po-base-product-details';
};
export const updateDirectPaymentStatusUrl = (params) => {
  return apiUrl + `/user-orders/update-payment-status-cement-co`;
};

export const sellViaInventoryInvoicingUrl = (params) => {
  return apiUrl + `/user-orders/invoicing`;
};

export const convertPrimaryOrderToSecondaryOrderUrl = (params) => {
  return apiUrl + `/user-orders/create-primary-order-from-secondary-order`;
};

export const getOrderBookingPaginatedUrl = () => {
  return apiUrl + '/order-booking/paginated';
};

export const getOrderBookingDetailsForOrderIDUrl = () => {
  return apiUrl + '/order-booking/po-details';
};

export const getOrderPaginatedUrl = () => {
  return apiUrl + '/user-orders/paginated';
};

export const getPurchaseOrderDetailsUrl = () => {
  return apiUrl + '/user-orders/order-details';
};

export const compareProductPricesBetweenTwoStatesUrl = () => {
  return (
    apiUrl + '/product-prices/compare-product-prices-between-two-districts'
  );
};
export const compareProductPricesBetweenTwoPricingGeographyUrl = () => {
  return (
    apiUrl + '/product-prices/compare-product-prices-between-two-pricing-geography'
  );
};

export const getSearchProductsUrl = () => {
  return apiUrl + '/v2/search/products';
};

export const updateOrderDetailsUrl = () => {
  return apiUrl + '/user-orders/modify-order';
};

export const getOrdersByOrderBookingIdUrl = () => {
  return apiUrl + `/order-booking/get-orders-by-order-booking-id`;
};
export const getInvoicesPaginatedUrl = () => {
  return apiUrl + '/user-invoices/paginated';
};
export const getInvoiceDetailedUrl = () => {
  return apiUrl + '/user-invoices/detail';
};
